// extracted by mini-css-extract-plugin
export var hidden = "_of-1";
export var visible = "_of-0";